import React from 'react';
import { CommonTriggerProps } from './types';
import Styled from './DropdownTrigger.styles';

export type BoxDropdownTriggerProps = Omit<
  React.InputHTMLAttributes<HTMLInputElement>,
  'onSelect' | 'value'
> & {
  /** The text to be displayed in the error message. If it doesn't evaluate to false, the component will be in an error state. */
  errorMessage?: string;

  value?: string | number;

  isPlaceholder?: boolean;
};

/**
 * Dropdown (box) style trigger for Dropdowns or DropdownCheckboxLists.
 */
export const BoxDropdownTrigger = ({
  disabled,
  errorMessage,
  handleKeyDown,
  value,
  placeholder,
  isPlaceholder,
  toggleDropdown,
  expanded,
  id,
  ...rest
}: BoxDropdownTriggerProps & CommonTriggerProps): JSX.Element => {
  return (
    <Styled.InputSection onClick={(e) => !disabled && toggleDropdown(e)}>
      <Styled.Input
        error={Boolean(errorMessage)}
        disabled={disabled}
        onKeyDown={handleKeyDown}
        value={value || placeholder}
        isPlaceholder={isPlaceholder}
        data-expanded={expanded}
        readOnly
        id={id}
        {...rest}
      />
      <Styled.StyledCaret direction={expanded ? 'up' : 'down'} disabled={disabled} />
    </Styled.InputSection>
  );
};
